import { __rest, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { DropdownContent } from '../../Dropdown/DropdownContent.js';
import { Box } from '../../Box/index.js';
import { useMenuList } from '../useMenuList/useMenuList.js';

var MenuList = function (_a) {
    var children = _a.children, _b = _a.align, align = _b === void 0 ? "left" : _b, _c = _a.themeKey, themeKey = _c === void 0 ? "menuList" : _c, boxShadow = _a.elevation, portal = _a.portal, props = __rest(_a, ["children", "align", "themeKey", "elevation", "portal"]);
    var menuListProps = useMenuList({ align: align, portal: portal }).props;
    return (jsx(DropdownContent, __assign({}, menuListProps, { children: jsx(Box, __assign({ sx: __assign({}, (boxShadow && { boxShadow: boxShadow })), themeKey: themeKey }, props, { children: children })) })));
};

export { MenuList };
//# sourceMappingURL=MenuList.js.map
